export function parseUTCDate(dateString): Date {
    // This is the format we get from the Python backend if the backend dates are in UTC time
    const expectedDateFormat = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d\+00:00$/;
    const match = dateString.match(expectedDateFormat);
    if (!match) {
        throw Error(`Unexpected date format: ${dateString}`);
    }
    return new Date(dateString);
}

export function shortenUTCDateToMinutes(dateString): string {
    const expectedDateFormat = /^(\d{4}-\d\d-\d\d)T(\d\d:\d\d):\d\d\+00:00$/;
    const match = dateString.match(expectedDateFormat);
    if (!match) {
        throw Error(`Unexpected date format: ${dateString}`);
    }
    return match[1] + ' ' + match[2];
}

export function formatDateToYYYYMMDD(date: Date | string): string {
    if (typeof date === 'string') {
        date = new Date(date);
    }

    if (!(date instanceof Date) || isNaN(date.getTime())) {
        throw Error(`Invalid date instance: ${date}`);
    }
    try {
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    } catch (err) {
        throw Error(`Error in Formatting Date, provided date [[${date}]] is invalid: ${err}`);
    }
}
